var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[ (_vm.isTouch || _vm.isIE) ? 'u-absolute u-fit' : 'u-fixed u-fit-w u-pos-tl u-overflow-h' ]},[_vm._t("default"),(_vm.progression)?_c('div',{ref:"line",staticClass:"c-progression u-fixed u-pos-tl u-fit-w"}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }